export const EXAM_CHILD_INIT = 'EXAM_CHILD_INIT';
export const EXAM_CHILD_FETCHING = 'EXAM_CHILD_FETCHING';
export const EXAM_CHILD_SUCCESS = 'EXAM_CHILD_SUCCESS';
export const EXAM_CHILD_FAIL = 'EXAM_CHILD_FAIL';

export const EXAM_DETAILS_INIT = 'EXAM_DETAILS_INIT';
export const EXAM_DETAILS_FETCHING = 'EXAM_DETAILS_FETCHING';
export const EXAM_DETAILS_SUCCESS = 'EXAM_DETAILS_SUCCESS';
export const EXAM_DETAILS_FAIL = 'EXAM_DETAILS_FAIL';
